module.exports = "li.active a {\n    background-color:  #337ab7;\n    border-color:  #2e6da4;\n    color:  #fff;\n}\n.pagination { cursor: pointer; }"


//////////////////
// WEBPACK FOOTER
// ./client/views/request/stepper/stepper.component.css
// module id = ./client/views/request/stepper/stepper.component.css
// module chunks = main